import { FragmentType, useMutation, useApolloClient } from "@apollo/client";
import { EXPIRE_PERSON_MUTATION } from "../../../features/graphql/mutation/person/expirePersonMutation";
import { useState } from "react";
import { ExpirePersonMutation, ExpirePersonMutationVariables, PeopleForLinkQuery } from "../../../__generated__/graphql";
import { PEOPLE_FOR_LINK_QUERY } from "../../../features/graphql/query/person/getPeopleForLink";
import { getFragmentData } from "../../../__generated__";
import { PEOPLE_FOR_LINK__PERSON_FRAGMENT } from "../../../features/graphql/query/person/fragments/peopleForLink__person";
import { PERSON_FOR_LINK_QUERY } from "../../../features/graphql/query/person/getPersonForLink";
import { PersonDataType, useSelectedPerson } from "../../../context/SelectedPersonContext";

const useExpirePerson = () => {
  const { setSelectedPerson } = useSelectedPerson();
  const [expirePersonMutation, { loading }] =
    useMutation<ExpirePersonMutation, ExpirePersonMutationVariables>(EXPIRE_PERSON_MUTATION);

  const [personToDelete, setPersonToDelete] = useState<string>();
  const client = useApolloClient();
  const expirePerson = async (personId: string) => {
    await expirePersonMutation({
      variables: {
        personId,
      },
      refetchQueries: [{
        query: PERSON_FOR_LINK_QUERY,
        variables: {
          personId
        }
      }],
      update(cache) {
        const people = cache.readQuery<PeopleForLinkQuery>({ query: PEOPLE_FOR_LINK_QUERY });

        const newPeople = people?.persons.map(person => {
          // const fragment = getFragmentData(PEOPLE_FOR_LINK__PERSON_FRAGMENT, person);
          const fragment = getFragmentData(PEOPLE_FOR_LINK__PERSON_FRAGMENT, person as FragmentType<typeof PEOPLE_FOR_LINK__PERSON_FRAGMENT>);
          if (fragment.id !== personId) return fragment;

          const updateFragment = {
            ...fragment,
            expired: true
          }

          setSelectedPerson(updateFragment as PersonDataType);

          return updateFragment
        });
        const person = newPeople?.find(p => p.id === personId);

        if (person) {
          cache.writeFragment({
            id: cache.identify(person),
            fragment: PEOPLE_FOR_LINK__PERSON_FRAGMENT,
            data: person
          });
        }
        // newPeople?.forEach(person => {
        //   cache.writeFragment({
        //     id: cache.identify(person),
        //     fragment: PEOPLE_FOR_LINK__PERSON_FRAGMENT,
        //     data: person
        //   })
        // })

        // cache.writeQuery<PeopleForLinkQuery>({
        //   query: PEOPLE_FOR_LINK_QUERY,
        //   data: { persons: newPeople as PeopleForLinkQuery['persons'] ?? [] }
        // });
      }
    })

  }


  const onExpirePerson = async (id: string) => {
    await expirePerson(id);
    setPersonToDelete(undefined);
  };

  return { expirePerson, onExpirePerson, savingExpirePerson: loading, setPersonToDelete, personToDelete };
};

export { useExpirePerson };
